<script setup lang="ts">
import { useUIStore } from "@/stores";
import { storeToRefs } from "pinia";
const { doStop } = storeToRefs(useUIStore());

const apiUrl = import.meta.env.VITE_APP_API_URL;
</script>

<template>
  <v-overlay :model-value="doStop.stop" class="align-center justify-center" persistent>
    <v-container fill-height class="d-flex align-center justify-center bg-surface">
      <v-row class="ma-0">
        <v-col class="pa-0">
          <v-row class="ma-0 my-6" v-if="doStop.img" justify="center">
            <v-img
              :aspect-ratio="doStop.imgProps ? undefined : 1"
              :width="doStop.imgProps ? undefined : '80vw'"
              :max-width="doStop.imgProps ? undefined : '105px'"
              :src="doStop.img"
              :style="doStop.imgProps"
            ></v-img>
          </v-row>
          <h1 class="mx-3 stop__message">{{ doStop.msg }}</h1>
          <v-row justify="center" class="my-4" v-if="doStop.btnTitle">
            <v-btn
              class="mx-auto"
              @click="doStop.btnAction.call()"
              color="green darken-4"
              variant="tonal"
            >
              {{ doStop.btnTitle }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<style scoped>
.stop__message {
  font-size: 1.3rem;
  line-height: 1;
  text-align: center;
}

@media (max-width: 768px) {
  .stop__message {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .stop__message {
    font-size: 1rem;
  }
}
</style>
